import { render, staticRenderFns } from "./SalesReportsCharts.vue?vue&type=template&id=543fb64c&scoped=true"
import script from "./SalesReportsCharts.vue?vue&type=script&lang=js"
export * from "./SalesReportsCharts.vue?vue&type=script&lang=js"
import style0 from "./SalesReportsCharts.vue?vue&type=style&index=0&id=543fb64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543fb64c",
  null
  
)

export default component.exports